import './tagsList.scss';
import React, { Component } from 'react';
import Tag from '../tag/Tag';

const TagsList = ({ items }) => {
    return (
        <div className="value b-tags-list">
            {
                items.map((title, i) => <Tag title={title} name={title} key={i} />)
            }
        </div>
    );
};

export default TagsList;
